// removed by extract-text-webpack-plugin
module.exports = {"root":"vmcCi","button":"_1vEO9","link":"_1rwHw","boxes":"_2JteP"};


//////////////////
// WEBPACK FOOTER
// ../source/views/ActivitiesAndSchools/styles.css
// module id = 1609
// module chunks = 17